import { Link } from 'react-router-dom'
import { format, parseISO } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers'
import { IsGranted } from '../../../app/modules/auth/PrivateRoute'
import { ROLE, useAuth } from '../../../app/modules/auth'
import { IClientItem } from '../../../app/modules/clients/core/_models'
import { TruncatedValue } from '../../../app/common/TruncatedValue'

export const ClientItem = (props: {
  client: IClientItem
  setClient: (client: IClientItem) => void
  chooseClient: boolean
  showFlagColumn?: boolean
}) => {
  const client = props.client
  const { currentUser } = useAuth()

  // Списки ролей повторяют видимость полей на бэкенде
  // (ExternalUserRepository::getExternalUserListQuery): кассир не видит ни комментарий,
  // ни риск-балл, обычный оператор — только комментарий.
  const showComment = IsGranted(
    [
      ROLE.ROLE_ADMIN,
      ROLE.ROLE_MANAGER,
      ROLE.ROLE_OPERATOR,
      ROLE.ROLE_MATCHING_OPERATOR,
      ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
      ROLE.ROLE_MERCHANT_MANAGER,
    ],
    currentUser
  )

  const showRiskPoints = IsGranted(
    [
      ROLE.ROLE_ADMIN,
      ROLE.ROLE_MANAGER,
      ROLE.ROLE_MATCHING_OPERATOR,
      ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
      ROLE.ROLE_MERCHANT_MANAGER,
    ],
    currentUser
  )

  return (
    <tr>
      {props.showFlagColumn ? (
        <td>
          {
            <img
              src={toAbsoluteUrl(`/media/flags/${client?.color}.svg`)}
              alt=''
              className='w-30px'
            />
          }
        </td>
      ) : null}
      <td>
        {IsGranted(
          [ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_SENIOR_OPERATOR, ROLE.ROLE_OPERATOR, ROLE.ROLE_MATCHING_OPERATOR, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER],
          currentUser
        ) ? (
          <Link to={'/client/info/' + client.token} className='text-primary' target='_blank'>
            <TruncatedValue value={client.externalId} focusable={false} />
          </Link>
        ) : (
          <TruncatedValue value={client.externalId} />
        )}
      </td>
      {IsGranted([ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER], currentUser) && (
        <>
          <td>
            <div>{client?.merchantTitle}</div>
          </td>
          <td>{client?.paymentSum || '-'}</td>
          <td>{client?.payoutSum || '-'}</td>
        </>
      )}

      {showRiskPoints && <td>{client.riskPoints ?? '-'}</td>}
      {showComment && (
        <td>
          <div className='text-truncate mw-250px' title={client.comment || undefined}>
            {client.comment?.trim() ? client.comment : '-'}
          </div>
        </td>
      )}

      <td>
        {client.lastActivityDate
          ? formatInTimeZone(parseISO(client?.lastActivityDate), '+03:00', 'dd.MM.yyyy HH:mm')
          : ''}
      </td>
      <td>{formatInTimeZone(parseISO(client?.createdAt), '+03:00', 'dd.MM.yyyy HH:mm')}</td>
      {props.chooseClient ? (
        <td className='float-right'>
          <button
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 me-4'
            onClick={() => {
              props.setClient(client)
            }}
          >
            <KTIcon className='fs-1' iconName='check-square' />
          </button>
        </td>
      ) : (
        ''
      )}
    </tr>
  )
}
